export default class SpeedController {
    constructor(aiParent) {
        this.aiParent = aiParent;
        this.engaged = false;
        this.countDown = 8;
        this.speedStep = 0;

        this.countdownTimer = null;
        this.speedSteps = [ 12, 3, 1, 0 ]; // , 0
        this.loopCounter = 0;

        this.concuring = false;

    }

    isEngaged = () => {
        return this.engaged;
    }

    decrementCountdown = () => {
        --this.countDown;
        this.countdownLoop();
    };

    countdownLoop = () => {
        ++this.loopCounter;
        clearTimeout(this.countdownTimer);
        if (this.countDown === 0) {
            this.concurFromLoop();
        } else if (!this.concuring && this.countDown > 0) {
            this.countdownTimer = setTimeout(this.decrementCountdown, 1000);
        } else {
            console.error('countdownLoop when in progress.', this.loopCounter)
        }
    };

    beginCountdown = () => {
        clearTimeout(this.countdownTimer);
        this.countDown = this.speedSteps[this.speedStep];
        this.countdownLoop();
    };

    stopCountdown = () => {
        clearTimeout(this.countdownTimer);
    };

    setSpeed = () => {
        clearTimeout(this.countdownTimer);
        let newSpeed = this.speedStep + 1;
        if (newSpeed === this.speedSteps.length) {
            newSpeed = 0;
        }
        this.speedStep = newSpeed;
        this.countDown = this.speedSteps[newSpeed];
        this.countdownLoop();
    };

    belay = () => {
        this.stopCountdown();
        this.engaged = false;
        this.aiParent.belay();
    };
    concur = () => {
        this.stopCountdown();
        this.concuring = true;
        this.aiParent.concur();
    };

    concurFromLoop = () => {
        console.log('concurFromLoop');
        this.concur();
    }

    toggleEngagement = () => {
        if (this.engaged) {
            this.stopCountdown();
        } else {
            this.beginCountdown();
            this.aiParent.autoEngaged();
        }
        this.engaged = !this.engaged;
    };

    waitToConcur = () => {
        this.concuring = false;
        this.stopCountdown();
        if (this.engaged) {
            this.beginCountdown();
        }
    };
}
